// NOTE: Really, this is a userLooks(?) store.

import find from 'lodash/find'
import get from 'lodash/get'
import indexOf from 'lodash/indexOf'
import {createSelector} from 'reselect'

import {hasLength} from '../utils'

// An object that contains both participants and user array
export const people = (state) => get(state, 'people')

// list of objects containing a look id (lookId) and all assigned participants
//  (i.e. userEventLookId) addded by the current user
// thus, if the user is a participant, you can always expect this to be empty
export const participantsGroupedByLookId = (state) => get(state, 'people.participants')

// list of look ids that the current user has added for themself
// thus, if the user is a participant, you can always expect this to be empty
export const user = (state) => get(state, 'people.user')

export const isOwnerWearingLook = (state, lookId) => indexOf(user(state), lookId) > -1

export const findParticipantsWearingLookByLookId = (state, lookId) =>
  get(find(participantsGroupedByLookId(state), {lookId}), 'wearers')

export const hasParticipants = createSelector(participantsGroupedByLookId, hasLength)
